import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { translateBackend } from 'assets/i18n/config';
import CustomFieldRenderer from 'ovComponents/3-pattern/customField/customFieldRenderer';
import { kebabCase } from 'lodash/fp';
import { invalidFields } from '../../workflowCompletion/subSteps/utils';
import { Button, Form } from '../../../2-component';
import { Box } from '../../../1-primative';

export const CustomFieldsDisplayVisual = ({
  options,
  objectData,
  updating,
  setObjectData,
  activeCustomFields,
  ignoreCustomFieldTriggerRules,
  submit,
}: {
  options: any;
  objectData: any;
  updating: boolean;
  setObjectData: any;
  activeCustomFields?: string[];
  ignoreCustomFieldTriggerRules?: boolean;
  submit: () => void;
}) => {
  const { t } = useTranslation('client');
  const [focused, setFocused] = useState<string[]>([]);
  const [updated, setUpdated] = useState<boolean>(false);
  const [customOptionSelected, setCustomOptionSelected] = useState<any[]>([]);

  useEffect(() => {
    const customOptions: any[] = [];
    Object.keys(options).forEach((key: string) => {
      if (options[key]?.customField && options[key].enabled && activeCustomFields?.includes(key)) {
        customOptions.push(options[key]);
      }
    });
    setCustomOptionSelected(customOptions);
  }, [options, activeCustomFields]);

  const update = (newValue: any) => {
    setObjectData(newValue);
    setUpdated(true);
  };

  const doSubmit = () => {
    const fields = invalidFields(
      {
        ...options,
      },
      objectData,
    );

    setFocused(fields);

    if (fields.length === 0) {
      setUpdated(false);
      submit();
    }
  };

  const lockedMessage = options.customLockedMessage ? translateBackend(options.customLockedMessage) : undefined;

  return (
    <Form onSubmit={doSubmit} testId='custom-fields-display-form'>
      <Box display='flex' flexDirection='column' gap={2}>
        <CustomFieldRenderer
          customOptions={customOptionSelected}
          customData={objectData}
          update={update}
          focused={focused}
          setFocused={setFocused}
          loading={updating}
          ignoreCustomFieldTriggerRules={ignoreCustomFieldTriggerRules}
          userId={objectData?.id}
          lockedMessage={lockedMessage}
        />
        <Box display='flex' justifyContent='flex-end'>
          {options.displayUpdateButton && (
            <Button label={t('update')} type='submit' disabled={updating || !updated} dataTestId={`custom-fields-display-${kebabCase(translateBackend(options?.customTitle))}-continue-button`} />
          )}
        </Box>
      </Box>
    </Form>
  );
};

export default CustomFieldsDisplayVisual;
